export const css = {
	root: '_26WNWkBa',
	' _key': 'lp-widgets/pagegroup'
};

export default css;
